/* =====================================================================
 * Header
 * =====================================================================
 * 1. Update Header Theme
 * ===================================================================*/

(function (doc, win) {

  /* ---------------------------------------------------------------------
   * 1. Update Header Theme
   * -------------------------------------------------------------------*/

  const isColliding = (a, b) => {
    const aRect = a.getBoundingClientRect();
    const bRect = b.getBoundingClientRect();
    return !(
      ((aRect.top + aRect.height) < (bRect.top)) ||
      (aRect.top > (bRect.top + bRect.height)) ||
      ((aRect.left + aRect.width) < bRect.left) ||
      (aRect.left > (bRect.left + bRect.width))
    );
  };

  const updateHeaderColor = () => {
    const header = doc.querySelector('.mainHeader');
    const sections = doc.querySelectorAll(':not(.slide)[data-color]');
    sections.forEach((section) => {
      const sectionTop = section.getBoundingClientRect().top;
      if (sectionTop <= 0 && isColliding(header, section)) {
        header.dataset.theme = section.dataset.color;
      }
    });
  };

  updateHeaderColor();
  win.addEventListener('scroll', () => updateHeaderColor());

}(document, window));
